import { PageRequest } from '@/app/core/models/paged-result.model';
import { Payroll, PayrollFilters, PayrollPage } from '../models/payroll.model';
import { toPageMeta } from './page-meta.api';
import { PayrollApiItem, PayrollApiResponse } from './payroll-api.types';

export function toApiQueryParams(
  filters: PayrollFilters,
  page: PageRequest,
): Record<string, string | number> {
  return { page: page.page, size: page.size, ...filters };
}

export function toPayroll(item: PayrollApiItem): Payroll {
  return { ...item };
}

export function toPayrollPage(response: PayrollApiResponse): PayrollPage {
  return { content: response.data.map(toPayroll), page: toPageMeta(response.meta) };
}
